import { ArticleHeading5 } from '@cian/ui-kit';

import { IconProductTrust16, IconProductEscrou16, IconProductSalesStart16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

interface IHouseTitleProps {
  name: string;
  gray: boolean;
  isReliable: boolean;
  isEscrow: boolean;
  isSalesStart?: boolean;
}

export function HouseTitle({ name, gray, isReliable, isEscrow, isSalesStart }: IHouseTitleProps) {
  return (
    <div className={styles['title']}>
      <ArticleHeading5 color={gray ? 'gray40_100' : 'text-primary-default'}>{name}</ArticleHeading5>
      <div className={styles['labels']}>
        {isReliable && <IconProductTrust16 color="icon-main-default" data-testid="IconTrust16" />}
        {isEscrow && <IconProductEscrou16 color="icon-main-default" data-testid="IconEscrou16" />}
        {isSalesStart && (
          <IconProductSalesStart16 color="icon-negative-default" viewBox="-1 -1 18 18" data-testid="IconSalesStart16" />
        )}
      </div>
    </div>
  );
}
